export const MIN_STYLE_SAMPLE_WORDS = 80;
